import { Component } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { AuthService } from './login/services/auth.service';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import {
    ActivatedRoute,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    RouterStateSnapshot,
  } from '@angular/router';
  import { filter } from 'rxjs/operators';

declare var gtag;
declare var ga;
declare var gapi;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers:[Angulartics2GoogleAnalytics]
})
export class AppComponent {


    constructor(
        public router: Router,
        private authService: AuthService,
        public angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics, 
        private angulartics2:Angulartics2) {
        angulartics2GoogleAnalytics.startTracking();
        this.googleAnalyticsConfig();
        this.trackUserEvent("view");
    }


    googleAnalyticsConfig(){
        const navEndEvent$ = this.router.events.pipe(
            filter((e) => e instanceof NavigationEnd)
          );
          const navStartEvent$ = this.router.events.pipe(
            filter((e) => e instanceof NavigationStart)
          );
      
          const navErrorEvent$ = this.router.events.pipe(
            filter((e) => e instanceof NavigationError)
          );
      
          navEndEvent$.subscribe((e: NavigationEnd) => {
            gtag('config', 'G-69RN486BTG', {
              page_path: e.urlAfterRedirects,
            });
      
            ga('create', 'G-69RN486BTG', 'auto');
            window.scroll(0, 0);
          });
      
        //   navStartEvent$.subscribe((e: NavigationStart) => {
        //     if (!navigator?.onLine) {
        //       setTimeout(() => {
        //         this.noInternetService.showInternetDialog(true);
        //       }, 100);
        //       return false;
        //     }
        //     this.commonService.hideLoader = false;
        //     this.commonService.resetLoader = true;
        //   });
      
        //   navErrorEvent$.subscribe((e: NavigationError) => {
        //     if (!navigator?.onLine) {
        //       setTimeout(() => {
        //         this.noInternetService.showInternetDialog(true);
        //       }, 100);
        //       return false;
        //     }
        //   });
    }


    // method to track event on google analtics
    trackUserEvent(action) {
        this.angulartics2.eventTrack.next({
          action,
          properties: {
            category: 'CustomCategory',
            label: `Add | Labels | Here`,
          },
        });
    }



}
